const mEditionProductSalesLettersModalDelete = {
  mEditionProductSalesLettersModalDelete: {
    alerts: {
      deleteProductoPaginaIdroop: {
        error: 'Un error ha ocurrido. Vuelve a intentarlo en un momento.',
        success: 'La carta de venta se eliminó exitosamente.'
      }
    },

    buttonCancel: 'CANCELAR',
    buttonPrimary: 'ELIMINAR',

    messageDelete: {
      element: 'Se eliminará la carta de venta ',
      options: 'y todas sus características de forma definitiva.',
      notReversed: 'Esta acción no podrá ser revertida.'
    },

    title: 'Eliminar Carta de Venta'
  }
}

export default mEditionProductSalesLettersModalDelete
